import SEOPage from "./SEOPage";

export default function IVFCostAmbala() {
  return (
    <SEOPage
      title="IVF Cost in Ambala | Affordable IVF Treatment"
      description="Know the IVF Cost in Ambala including treatment packages, consultation, laboratory procedures and fertility treatment options."
      canonical="https://amaanativf.com/ivf-cost-in-ambala"
      heading="IVF Cost in Ambala"
      focusKeyword="IVF Cost in Ambala"
    />
  );
}